import { connect } from 'react-redux'
import CustomNodeWidget from './CustomNodeWidget'
import { get } from 'lodash'

const stateToProps = ({ form, flows: { pricing } }, { node: { id } }) => ({
  pricing,
  form: get(form, id, {}),
})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(CustomNodeWidget)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/CustomNode/CustomNodeWidget/CustomNodeWidget.container.js